import { useEffect, useCallback } from 'react';

import type { LayoutServiceExperimentInfo } from '@sitecore/types/lib';
import { useRouter } from 'next/router';


import { useGTM } from './useGTM';

export const useExperimentTracking = (experimentInfo?: LayoutServiceExperimentInfo) => {
  const router = useRouter();
  const { pushToDataLayer } = useGTM();

  const handleRouteChange = useCallback(() => {
    if (!experimentInfo) return;
    pushToDataLayer({
      event: 'view_experiment',
      ...experimentInfo,
    });
  }, [experimentInfo, pushToDataLayer]);

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, handleRouteChange]);
};
